'use strict';

var config = require('../../../config.js')
exports = module.exports = {
  // List of user roles
  userRoles: ['guest', 'user', 'adminAperam', 'admin'],
  availableLanguages: ['Français', 'Anglais', 'Allemand'],
  baseUrl: config.baseUrl
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 22
// module chunks = 0